<template>
  <div class="voiceExplain">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item,index) in 4" :key="index">
        <img src="https://daolansassoss.oss-cn-zhangjiakou.aliyuncs.com/temp/1621853078002.jpg" alt="">
      </van-swipe-item>
    </van-swipe>
    <div class="musicProgress">
      <h4>讲解音频</h4>
      <img class="musicBtn" src="../../assets/play.png" alt="">
      <van-slider button-size="18px"  bar-height="8px" inactive-color="#E6E6E6" active-color="#4B1919" v-model="sliderValue" @change="onChange" />
      <div class="time">00:50</div>
    </div>
    <div class="musicInfo musicProgress">
      <h4>详细介绍</h4>
      <P>
        中国的香文化源远流长，内涵丰富，传承有序。先民最初焚燃香草的习俗与祭祀相关，在众多遗址、遗物中留下了痕迹。汉代丝路畅通，树脂类香料开始传入中原；同时，原产于东方的麝香源源不断地向域外输出。香料成为中外文化交流的重要载体。

        随着历史的发展，在宗教和文人的推动下，上自朝堂，下至市井，皆习香事。各类香料广泛应用、各种香器应运而生，各种情感赋予其中。隋唐的富贵奢华、宋元的清远素净、明清的千姿百态，风骨不同，各具特色。香文化日益融入普通民众生活，其内涵越来越丰富，其意义越来越宏阔。从神秘高远的祭祀，到奢侈华贵的庙堂；从清雅馨香的书房，到大众百姓美好生活的精神寄托，独具神韵的东方香魂散发着无穷的魅力。
      </P>
    </div>
  </div>
</template>

<script>

export default {
  name: 'voiceExplain.vue',
  data () {
    return {
      sliderValue: 50
    }
  },
  mounted () {
  },
  methods: {
    onChange (value) {
      console.log(value)
    }
  }
}
</script>

<style lang="scss" scoped>
.voiceExplain {
    padding: 13px;
    min-height: 100vh;
    box-sizing: border-box;
    background-color: rgba(235, 235, 235, 0.5);
    .my-swipe {
      border-radius: 13px;
      overflow: hidden;
      margin-bottom: 30px;
      .van-swipe-item {
        height:260px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .musicProgress {
      position:relative;
      background-color: #fff;
      border-radius: 13px;
      overflow: hidden;
      margin-bottom: 53px;
      .musicBtn {
        position: absolute;
        width: 40px;
        height: 40px;
        right: 30px;
        top: 10px;
      }
      h4 {
        padding-top: 13px;
        padding-left: 7px;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        padding-bottom: 35px;
        margin: 0;
      }
      .van-slider {
        width: 85%;
        margin: 0 auto 12px;
      }
      .time {
        width: 85%;
        text-align: right;
        margin: 0 auto 12px;
        font-size: 12px;
        color: #CCCCCC;
        padding-right: 12px;
      }
    }
    .musicInfo {
      h4 {
        margin-bottom: 17px;
        padding-bottom: 0;
      }
      p {
        margin: 0 19px;
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        line-height: 2;
      }
    }
  }
</style>
